import React, { useState } from 'react'
import axios from 'axios'
import styled from 'styled-components'
import closeImg from '../../assets/close.png'
const apiUrl =
    process.env.NODE_ENV === 'production'
        ? '/api'
        : process.env.REACT_APP_API_URL
const StyledLogingFormContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(158, 18, 18, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
`
const StyledLogingFormBox = styled.div`
    width: 80%;
    height: 80%;
    background-color: #5c83ab;
    display: flex;
    justify-content: center;
    align-items: center;
`

const LoginForm = ({ setIsLoginVisible }) => {
    const handleClickClose = () => {
        setIsLoginVisible(false)
    }

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        setError(null)

        try {
            const response = await axios.post(
                `${apiUrl}/auth/login`, // URL du backend
                { email, password },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true, // Inclut les cookies dans la requête
                }
            )

            if (response.status === 200) {
                setIsLoginVisible(false)
                window.location.reload()
            }
        } catch (err) {
            setError(
                'Identifiants incorrects ou adresse email pas encore vérifiée'
            )
        } finally {
            setLoading(false)
        }
    }

    return (
        <StyledLogingFormContainer>
            <StyledLogingFormBox>
                <img
                    src={closeImg}
                    alt="Close login window"
                    onClick={handleClickClose}
                    style={{ width: '20px' }}
                />
                <h2>Login</h2>
                <form onSubmit={handleSubmit}>
                    <div>
                        <label>Email:</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <div>
                        <label>Password:</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Loading...' : 'Login completed'}
                    </button>
                </form>
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </StyledLogingFormBox>
        </StyledLogingFormContainer>
    )
}

export default LoginForm
